import CommodityDto from './Commodity'
import { todayLocalDate } from '../services/common/UtilsFunctions'

let IncomeDto = {
  id: -1,
  analysis: null,
  incomeNo: '',
  waybill: '',
  depositCertificate: '',
  ctg: '',
  grossWeight: '',
  truckWeight: '',
  commodities: CommodityDto,
  driverName: '',
  truckPatent: '',
  trailerPatent: '',
  waybillOwner: null,
  commercialSender: null,
  receiver: null,
  transporter: null,
  origin: null,
  downloadDate: todayLocalDate(),
  obs: null,
  imgDir: null
}

export default IncomeDto
